var React = require('react');

function IconMore (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_193","data-name":"Group 193","transform":"translate(-3460.957 331.195)"},[React.createElement("circle",{"id":"Ellipse_7","data-name":"Ellipse 7","cx":"6.28","cy":"6.28","r":"6.28","transform":"translate(3485.564 -321.777)","fill":"#161412","key":0}),React.createElement("path",{"id":"Path_525","data-name":"Path 525","d":"M3522.685-315.5l-10.924-6.307-9.654-5.574a15.636,15.636,0,0,0-10.26-3.817,15.635,15.635,0,0,0-10.152,3.725l-9.813,5.666-10.924,6.307,10.924,6.307,9.813,5.666a15.634,15.634,0,0,0,10.152,3.725,15.636,15.636,0,0,0,10.26-3.817l9.654-5.574Zm-30.838,7.97a7.97,7.97,0,0,1-7.97-7.97,7.97,7.97,0,0,1,7.97-7.97,7.97,7.97,0,0,1,7.97,7.97A7.97,7.97,0,0,1,3491.846-307.527Z","fill":"#161412","key":1})]));
}

IconMore.defaultProps = {"width":"61.728","height":"31.396","viewBox":"0 0 61.728 31.396"};

module.exports = IconMore;

IconMore.default = IconMore;
